export default "__VITE_ASSET__01d1cd32__"